/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeCatalogListAccelerators } from "../../funcs/computeCatalogListAccelerators.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListAcceleratorsRequest$inboundSchema,
};

export const tool$computeCatalogListAccelerators: ToolDefinition<typeof args> =
  {
    name: "compute-catalog-list-accelerators",
    description: `List accelerators`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await computeCatalogListAccelerators(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
